<template>
    <i
        :class="iconClass"
        :style="iconStyles"
        class="WIcon"
        @click="$emit('click')"
    />
</template>

<script>
import VueTypes from 'vue-types'

const colors = ['', 'white', 'primary', 'secondary', 'accent-blue', 'dark', 'grayMedium', 'grayLight', 'black', 'yellow', 'red', 'green', 'blue', 'turquoise', 'cyan', 'violet', 'pink']
export default {
    name: 'WIcon',
    props: {
        icon: VueTypes.string.isRequired.def(''),
        color: VueTypes.oneOf(colors).def(''),
        size: VueTypes.number.def(0),
        clickable: VueTypes.bool.def(false),
    },
    data () {
        return {}
    },
    computed: {
        iconClass () {
            return [
                [
                    `icon-${this.icon}`,
                    this.color,
                    this.clickable ? 'clickable' : '',
                ],
            ]
        },
        iconStyles () {
            const styles = {}
            if (this.size) styles.fontSize = `${this.size}px`
            return styles
        },
    },
}
</script>

<style scoped lang="scss">
.WIcon {
    vertical-align: middle;
    color: $body-color;
    transition: all .3s ease-in-out;

    &.white {
        color: $white;
    }
    &.primary {
        color: $primary;
    }
    &.secondary {
        color: $secondary;
    }
    &.accent-blue {
        color: $accent-blue;
    }
    &.black {
        color: $black;
    }
    &.dark {
        color: $gray-01;
    }
    &.grayMedium {
        color: $gray-medium;
	}
    &.grayLight {
        color: $gray-03;
	}
    &.yellow {
        color: $warning;
    }
	&.red {
		color: $danger;
    }
    &.green {
        color: $success;
    }
    &.blue {
        color: $info;
    }
    &.turquoise {
        color: $turquoise;
    }
    &.cyan {
        color: $cyan;
    }
    &.violet {
        color: $violet;
    }
    &.pink {
        color: $pink;
    }

    &.clickable {
        cursor: pointer;
        &:hover{
            opacity: 0.5;
        }
    }
}
</style>
